<template>
<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <g stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
    <rect id="Rectangle" y="10.714" width="24" height="2.571"></rect>
    <polygon id="Rectangle" points="10.714 24 10.714 0 13.286 0 13.286 24" style="transform-origin: 12px 12px;"></polygon>
  </g>
</svg>
</template>
